// axios
import axios from 'axios'

const axiosSiteClient = axios.create({
	baseURL: process.env.VUE_APP_SITE_API_URL,
	headers: {
		'Access-Control-Allow-Origin' : '*',
		'Access-Control-Allow-Credentials' : 'true',
		'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
		'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
		'crossDomain': true,
		'crossOrigin': true,
	}
});

export default axiosSiteClient;
